<!--底部-->
<template>
  <div style="height: 40px;width: 100%;display: flex;flex-direction: row;align-items: center;">
    <el-dropdown
      placement="top-start"
      trigger="click"
      size="medium"
      :hide-on-click="false"
      ref="team_setting"
      style="max-width: 50%;"
    >
      <div class="innerChoose" style="max-width: 100%;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">
        <img src="@/assets/diapatch/group@2x.png" alt="">
  <!--      All teams-->
        <div v-for="(item,index) in teamListLabel" style="display: inline-block">{{item.name}} <span v-if="index < teamList.length - 1">,</span></div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a" disabled>
          <div class="topTitle">Teams</div>
        </el-dropdown-item>
        <el-dropdown-item  v-for="(item,index) in teamList" :command="item.value">
          <el-checkbox-group v-model="team_setting">
            <el-checkbox :label="item.value" :key="item.value + index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-dropdown-item>
        <el-dropdown-item divided command="f"  class="dividedBox">
          <div class="butomBox">
            <div class="cancel" @click="closeDropDown('team_setting')">Cancel</div>
            <div class="ok" @click="closeDrop('team_setting')">OK</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown
      placement="top-start"
      trigger="click"
      size="medium"
      :hide-on-click="false"
      ref="drivers_setting"
    >
      <div class="innerChoose">
        <img src="@/assets/diapatch/status@2x.png" alt="">
  <!--      All drivers-->
        <div v-for="(item,index) in driverListLabel" style="display: inline-block">
          {{item.name}} <span v-if="index < driverList.length - 1">,</span>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a" disabled>
          <div class="topTitle">Drivers</div>
        </el-dropdown-item>
        <el-dropdown-item  v-for="(item,index) in driverList" :command="item.value">
          <el-checkbox-group v-model="drivers_setting">
            <el-checkbox :label="item.value" :key="item.value + index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-dropdown-item>
        <el-dropdown-item divided command="f"  class="dividedBox">
          <div class="butomBox">
            <div class="cancel"  @click="closeDropDown('drivers_setting')">Cancel</div>
            <div class="ok" @click="closeDrop('drivers_setting')">OK</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown
      placement="top-start"
      trigger="click"
      size="medium"
      :hide-on-click="false"
      ref="task_setting"
    >
      <div class="innerChoose">
        <img src="@/assets/diapatch/status@2x(1).png" alt="">
        <div v-for="(item,index) in taskListLabel" style="display: inline-block">{{item.name}} <span v-if="index < taskList.length - 1">,</span></div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a" disabled>
          <div class="topTitle">Tasks</div>
        </el-dropdown-item>
        <el-dropdown-item  v-for="(item,index) in taskList" :command="item.value">
          <el-checkbox-group v-model="task_setting">
            <el-checkbox :label="item.value" :key="item.value + index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-dropdown-item>
        <el-dropdown-item divided command="f"  class="dividedBox">
          <div class="butomBox">
            <div class="cancel"  @click="closeDropDown('task_setting')">Cancel</div>
            <div class="ok" @click="closeDrop('task_setting')">OK</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
  </template>

  <script>
  import store from "@/store/index";
  import {getPublicData} from "@/api/dispatch";

  export default {
    name: "bottomBox",
    data(){
      return{
        scheduleDrop:'scheduleDrop',
        schedules_setting:[],
        team_setting:[],
        drivers_setting:[],
        task_setting:[],
        teamListLabel:[],
        taskListLabel:[],
        driverListLabel:[],
      }
    },
    computed:{
      teamList(){
        // console.log('store_test.state.setMes',store_test.state.setMes) //undefined
        if(store.state.setMes){
          return store.state.setMes.team_setting
        }
      },
      driverList(){
        if(store.state.setMes){
          return store.state.setMes.driver_setting
        }
      },
      taskList(){
        if(store.state.setMes){
          return store.state.setMes.task_setting
        }
      },
    },
     beforeMount() {
    },
    created() {
      getPublicData().then(async res=>{
        store.commit('setBtomSetting',res.data)
        let set = JSON.parse(localStorage.getItem('set_select'))
        if (!set || set.team_setting.length == 0){
          res.data.team_setting.forEach(v=>{this.team_setting.push(v.value)})
          res.data.task_setting.forEach(v=>{
            if  (v.value<3){
              this.task_setting.push(v.value)
            }
          })
          res.data.driver_setting.forEach(v=>{this.drivers_setting.push(v.value)})
          let obj = {
            team_setting:this.team_setting,
            task_setting:this.task_setting,
            drivers_setting:this.drivers_setting
          }
          localStorage.setItem('set_select',JSON.stringify(obj))
        }else {
          this.team_setting = set.team_setting
          this.task_setting = set.task_setting
          this.drivers_setting = set.drivers_setting
        }
        this.chooseLabel('team_setting')
        this.chooseLabel('drivers_setting')
        this.chooseLabel('task_setting')

      })

    },
    methods:{
      closeDropDown(e){
        this.$refs[e].hide()
      },
      closeDrop(e){
        this.$refs[e].hide()
        this.chooseLabel(e)
      },
      chooseLabel(e){
        let arr1 = []
        let arr2 = []
        let label = ''
        switch (e){
          case 'team_setting':{
            arr1 = this.team_setting
            arr2 = this.teamList
            label = 'teamListLabel'
            this.$emit('btomSetHandle',this.team_setting)
            break;
          }
          case 'drivers_setting':{
            arr1 = this.drivers_setting
            arr2 = this.driverList
            label = 'driverListLabel'
            this.$emit('btomSetDriverHandle',this.drivers_setting)
            break;
          }
          case 'task_setting':{
            arr1 = this.task_setting
            arr2 = this.taskList
            label = 'taskListLabel'
            break;
          }
        }
        let newArr = arr2?.filter((v) => arr1?.some((val) => val == v.value))
        this[label] = newArr
        let obj = {
          team_setting:this.team_setting,
          task_setting:this.task_setting,
          drivers_setting:this.drivers_setting
        }
        localStorage.setItem('set_select',JSON.stringify(obj))
          if (label == 'teamListLabel'){
            store.commit('teamHandle',this.team_setting)
            store.commit('changeMapDriver',this.drivers_setting)
          }
          if (label == 'driverListLabel'){
            store.commit('changeMapDriver',this.drivers_setting)
          }
          if (label == 'taskListLabel'){
            store.commit('teamHandle',this.team_setting)
          }
        store.commit("restartDrawLine");
      }
    }
  }
  </script>

  <style scoped lang="less">
  .innerChoose{
    font-size: 12px;
    font-weight: 400;
    color: #FFFFFF;
    padding: 0 12px;
    line-height: 22px;
    border: 1px solid #ffffff;
    margin: 8px;
    border-radius: 11px;
    cursor: pointer;
    img{
      height: 16px;
      vertical-align: middle;
      margin-right: 6px;
    }
  }
  .butomBox{
    display: flex;
    justify-content: flex-end;
    line-height: 20px !important;
    //margin-right: 12px;
    cursor: pointer;
    .cancel{
      font-size: 12px;
      font-weight: 400;
      color: #1F2D42;
      margin-right: 12px;
    }
    .ok{
      font-size: 12px;
      font-weight: 400;
      color: #E95646;
    }
  }
  .topTitle{
    font-weight: bold;
    color: #0F2D42;
  }
  .dividedBox{
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
  }
  .dividedBox:hover{
    background-color: #FFFFFF!important;
  }
  </style>
  <style>
  /deep/.change{
    padding: 0 !important;
  }
  </style>
